import { render, staticRenderFns } from "./b-ticket-travel-insurance-documents-addons.vue?vue&type=template&id=6bddce80&scoped=true"
import script from "./b-ticket-travel-insurance-documents-addons.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket-travel-insurance-documents-addons.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket-travel-insurance-documents-addons.vue?vue&type=style&index=0&id=6bddce80&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bddce80",
  null
  
)

export default component.exports